export default () => {

    const links = document.querySelectorAll('[data-sure]');
    const body = document.querySelector('body');

    for (const link of links) {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const message = link.getAttribute('data-sure');
            const title = link.getAttribute('data-title');
            const action = link.getAttribute('href');

            const html = `<div class="sure">
    <div class="sure__body">
        <div class="sure__inner">
            <div class="sure__message">
                <h4>${title}</h4>
                <p>${message}</p>
            </div>
            <div class="sure__actions">
                <button class="btn btn--small" data-sure-confirm>Confirm</button>
                <span data-sure-cancel>Cancel</span>
            </div>
        </div>
    </div>
</div>`;

            const holder = document.createElement('div');
            holder.innerHTML = html;

            body.append(holder);

            holder.querySelector('[data-sure-cancel]').addEventListener('click', () => {
                holder.remove();
            });

            holder.querySelector('[data-sure-confirm]').addEventListener('click', () => {
                window.location = action;
            });

            return false;
        })
    }
}
